import React, { useRef, useLayoutEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { useSelector } from 'react-redux';
import { getViewportDimensions, keepSpaceTogether } from '../../../../models/Utils';
import { ADAARIARoles } from '../../../../models/ADA';

import './SectionTitleVideo.scss';

const mobileScreenThreshold = 767; // MUST BE IN SYNC WITH CSS

const SectionTitleVideo = ({ videoUrlDesktop, videoUrlMobile, adaText }) => {
  const [onMobile, setOnMobile] = useState(false);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const refScreenWidth = useRef(-1);

  const handleResize = () => {
    const viewport = getViewportDimensions();
    if (refScreenWidth.current !== viewport.width) {
      setOnMobile(viewport.width <= mobileScreenThreshold);

      refScreenWidth.current = viewport.width;
    }
  };

  useLayoutEffect(() => {
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="vbn-section-title-video">
      <p className='sr-only'>{adaText}</p>
      <div className="vbn-stv-video-holder">
        <ReactPlayer
          url={onMobile ? videoUrlMobile : videoUrlDesktop}
          width={onMobile ? 320 : 640}
          height={onMobile ? 96 : 128}
          muted={true}
          loop={true}
          playing={true}
          volume={0}
        />
      </div>
    </div>
  );
};

export default SectionTitleVideo;